import React from "react";
import MuiAppBar from "@mui/material/AppBar";
import PropTypes from "prop-types";

/**
 * AppBar component wrapper for app headers.
 * Wraps Material-UI AppBar with theme integration.
 * 
 * @component
 * @example
 * <AppBar position="static">
 *   <Toolbar>
 *     <Typography variant="h6">App Title</Typography>
 *   </Toolbar>
 * </AppBar>
 */
const AppBar = ({ children, ...props }) => {
  return <MuiAppBar {...props}>{children}</MuiAppBar>;
};

AppBar.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * The color of the component
   */
  color: PropTypes.oneOf([
    "default",
    "inherit",
    "primary",
    "secondary",
    "transparent",
    "error",
    "info",
    "success",
    "warning",
  ]),
  /**
   * If true, the app bar will have no elevation
   */
  elevation: PropTypes.number,
  /**
   * If true, the app bar will be full width
   */
  enableColorOnDark: PropTypes.bool,
  /**
   * The positioning type
   */
  position: PropTypes.oneOf([
    "absolute",
    "fixed",
    "relative",
    "static",
    "sticky",
  ]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI AppBar behavior
// MUI AppBar defaults: color="primary", position="fixed"

export default AppBar;

